import { render, staticRenderFns } from "./reminds.vue?vue&type=template&id=a8302348&scoped=true&"
import script from "./reminds.vue?vue&type=script&lang=js&"
export * from "./reminds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8302348",
  null
  
)

export default component.exports